"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createExtent = createExtent;
exports.none = none;

var _math = require("./math.js");

/**
 * @module ol/centerconstraint
 */

/**
 * @typedef {function((import("./coordinate.js").Coordinate|undefined), number, import("./size.js").Size, boolean=, Array<number>=): (import("./coordinate.js").Coordinate|undefined)} Type
 */

/**
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {boolean} onlyCenter If true, the constraint will only apply to the view center.
 * @param {boolean} smooth If true, the view will be able to go slightly out of the given extent
 * (only during interaction and animation).
 * @return {Type} The constraint.
 */
function createExtent(extent, onlyCenter, smooth) {
  return (
    /**
     * @param {import("./coordinate.js").Coordinate|undefined} center Center.
     * @param {number|undefined} resolution Resolution.
     * @param {import("./size.js").Size} size Viewport size; unused if `onlyCenter` was specified.
     * @param {boolean} [opt_isMoving] True if an interaction or animation is in progress.
     * @param {Array<number>} [opt_centerShift] Shift between map center and viewport center.
     * @return {import("./coordinate.js").Coordinate|undefined} Center.
     */
    function (center, resolution, size, opt_isMoving, opt_centerShift) {
      if (!center) {
        return undefined;
      }

      if (!resolution && !onlyCenter) {
        return center;
      }

      var viewWidth = onlyCenter ? 0 : size[0] * resolution;
      var viewHeight = onlyCenter ? 0 : size[1] * resolution;
      var shiftX = opt_centerShift ? opt_centerShift[0] : 0;
      var shiftY = opt_centerShift ? opt_centerShift[1] : 0;
      var minX = extent[0] + viewWidth / 2 + shiftX;
      var maxX = extent[2] - viewWidth / 2 + shiftX;
      var minY = extent[1] + viewHeight / 2 + shiftY;
      var maxY = extent[3] - viewHeight / 2 + shiftY; // note: when zooming out of bounds, min and max values for x and y may
      // end up inverted (min > max); this has to be accounted for

      if (minX > maxX) {
        minX = (maxX + minX) / 2;
        maxX = minX;
      }

      if (minY > maxY) {
        minY = (maxY + minY) / 2;
        maxY = minY;
      }

      var x = (0, _math.clamp)(center[0], minX, maxX);
      var y = (0, _math.clamp)(center[1], minY, maxY); // during an interaction, allow some overscroll

      if (opt_isMoving && smooth && resolution) {
        var ratio = 30 * resolution;
        x += -ratio * Math.log(1 + Math.max(0, minX - center[0]) / ratio) + ratio * Math.log(1 + Math.max(0, center[0] - maxX) / ratio);
        y += -ratio * Math.log(1 + Math.max(0, minY - center[1]) / ratio) + ratio * Math.log(1 + Math.max(0, center[1] - maxY) / ratio);
      }

      return [x, y];
    }
  );
}
/**
 * @param {import("./coordinate.js").Coordinate} [center] Center.
 * @return {import("./coordinate.js").Coordinate|undefined} Center.
 */


function none(center) {
  return center;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFHQTs7QUFIQTs7OztBQUtBOzs7O0FBSUE7Ozs7Ozs7QUFPTSxTQUFVQSxZQUFWLENBQXVCQyxNQUF2QixFQUErQkMsVUFBL0IsRUFBMkNDLE1BQTNDLEVBQWlEO0VBQ3JEO0lBQ0U7Ozs7Ozs7O0lBUUEsVUFBVUMsTUFBVixFQUFrQkMsVUFBbEIsRUFBOEJDLElBQTlCLEVBQW9DQyxZQUFwQyxFQUFrREMsZUFBbEQsRUFBaUU7TUFDL0QsSUFBSSxDQUFDSixNQUFMLEVBQWE7UUFDWCxPQUFPSyxTQUFQO01BQ0Q7O01BQ0QsSUFBSSxDQUFDSixVQUFELElBQWUsQ0FBQ0gsVUFBcEIsRUFBZ0M7UUFDOUIsT0FBT0UsTUFBUDtNQUNEOztNQUNELElBQU1NLFNBQVMsR0FBR1IsVUFBVSxHQUFHLENBQUgsR0FBT0ksSUFBSSxDQUFDLENBQUQsQ0FBSixHQUFVRCxVQUE3QztNQUNBLElBQU1NLFVBQVUsR0FBR1QsVUFBVSxHQUFHLENBQUgsR0FBT0ksSUFBSSxDQUFDLENBQUQsQ0FBSixHQUFVRCxVQUE5QztNQUNBLElBQU1PLE1BQU0sR0FBR0osZUFBZSxHQUFHQSxlQUFlLENBQUMsQ0FBRCxDQUFsQixHQUF3QixDQUF0RDtNQUNBLElBQU1LLE1BQU0sR0FBR0wsZUFBZSxHQUFHQSxlQUFlLENBQUMsQ0FBRCxDQUFsQixHQUF3QixDQUF0RDtNQUNBLElBQUlNLElBQUksR0FBR2IsTUFBTSxDQUFDLENBQUQsQ0FBTixHQUFZUyxTQUFTLEdBQUcsQ0FBeEIsR0FBNEJFLE1BQXZDO01BQ0EsSUFBSUcsSUFBSSxHQUFHZCxNQUFNLENBQUMsQ0FBRCxDQUFOLEdBQVlTLFNBQVMsR0FBRyxDQUF4QixHQUE0QkUsTUFBdkM7TUFDQSxJQUFJSSxJQUFJLEdBQUdmLE1BQU0sQ0FBQyxDQUFELENBQU4sR0FBWVUsVUFBVSxHQUFHLENBQXpCLEdBQTZCRSxNQUF4QztNQUNBLElBQUlJLElBQUksR0FBR2hCLE1BQU0sQ0FBQyxDQUFELENBQU4sR0FBWVUsVUFBVSxHQUFHLENBQXpCLEdBQTZCRSxNQUF4QyxDQWQrRCxDQWdCL0Q7TUFDQTs7TUFDQSxJQUFJQyxJQUFJLEdBQUdDLElBQVgsRUFBaUI7UUFDZkQsSUFBSSxHQUFHLENBQUNDLElBQUksR0FBR0QsSUFBUixJQUFnQixDQUF2QjtRQUNBQyxJQUFJLEdBQUdELElBQVA7TUFDRDs7TUFDRCxJQUFJRSxJQUFJLEdBQUdDLElBQVgsRUFBaUI7UUFDZkQsSUFBSSxHQUFHLENBQUNDLElBQUksR0FBR0QsSUFBUixJQUFnQixDQUF2QjtRQUNBQyxJQUFJLEdBQUdELElBQVA7TUFDRDs7TUFFRCxJQUFJRSxDQUFDLEdBQUcsaUJBQU1kLE1BQU0sQ0FBQyxDQUFELENBQVosRUFBaUJVLElBQWpCLEVBQXVCQyxJQUF2QixDQUFSO01BQ0EsSUFBSUksQ0FBQyxHQUFHLGlCQUFNZixNQUFNLENBQUMsQ0FBRCxDQUFaLEVBQWlCWSxJQUFqQixFQUF1QkMsSUFBdkIsQ0FBUixDQTVCK0QsQ0E4Qi9EOztNQUNBLElBQUlWLFlBQVksSUFBSUosTUFBaEIsSUFBMEJFLFVBQTlCLEVBQTBDO1FBQ3hDLElBQU1lLEtBQUssR0FBRyxLQUFLZixVQUFuQjtRQUNBYSxDQUFDLElBQ0MsQ0FBQ0UsS0FBRCxHQUFTQyxJQUFJLENBQUNDLEdBQUwsQ0FBUyxJQUFJRCxJQUFJLENBQUNFLEdBQUwsQ0FBUyxDQUFULEVBQVlULElBQUksR0FBR1YsTUFBTSxDQUFDLENBQUQsQ0FBekIsSUFBZ0NnQixLQUE3QyxDQUFULEdBQ0FBLEtBQUssR0FBR0MsSUFBSSxDQUFDQyxHQUFMLENBQVMsSUFBSUQsSUFBSSxDQUFDRSxHQUFMLENBQVMsQ0FBVCxFQUFZbkIsTUFBTSxDQUFDLENBQUQsQ0FBTixHQUFZVyxJQUF4QixJQUFnQ0ssS0FBN0MsQ0FGVjtRQUdBRCxDQUFDLElBQ0MsQ0FBQ0MsS0FBRCxHQUFTQyxJQUFJLENBQUNDLEdBQUwsQ0FBUyxJQUFJRCxJQUFJLENBQUNFLEdBQUwsQ0FBUyxDQUFULEVBQVlQLElBQUksR0FBR1osTUFBTSxDQUFDLENBQUQsQ0FBekIsSUFBZ0NnQixLQUE3QyxDQUFULEdBQ0FBLEtBQUssR0FBR0MsSUFBSSxDQUFDQyxHQUFMLENBQVMsSUFBSUQsSUFBSSxDQUFDRSxHQUFMLENBQVMsQ0FBVCxFQUFZbkIsTUFBTSxDQUFDLENBQUQsQ0FBTixHQUFZYSxJQUF4QixJQUFnQ0csS0FBN0MsQ0FGVjtNQUdEOztNQUVELE9BQU8sQ0FBQ0YsQ0FBRCxFQUFJQyxDQUFKLENBQVA7SUFDRDtFQW5ESDtBQXFERDtBQUVEOzs7Ozs7QUFJTSxTQUFVSyxJQUFWLENBQWVwQixNQUFmLEVBQXFCO0VBQ3pCLE9BQU9BLE1BQVA7QUFDRCIsIm5hbWVzIjpbImNyZWF0ZUV4dGVudCIsImV4dGVudCIsIm9ubHlDZW50ZXIiLCJzbW9vdGgiLCJjZW50ZXIiLCJyZXNvbHV0aW9uIiwic2l6ZSIsIm9wdF9pc01vdmluZyIsIm9wdF9jZW50ZXJTaGlmdCIsInVuZGVmaW5lZCIsInZpZXdXaWR0aCIsInZpZXdIZWlnaHQiLCJzaGlmdFgiLCJzaGlmdFkiLCJtaW5YIiwibWF4WCIsIm1pblkiLCJtYXhZIiwieCIsInkiLCJyYXRpbyIsIk1hdGgiLCJsb2ciLCJtYXgiLCJub25lIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNyYy9jZW50ZXJjb25zdHJhaW50LmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19